module.exports = __webpack_public_path__ + "static/young-leader-photo-shavin_fernando-d864f0d1f2c07b0236a28267ac0b2be1.jpg";